import dashboardBundleService from '@/services/dashboard/event_dashboard_bundle'

function buildSegment(label, value, total, color) {
  const safeValue = Number(value || 0)
  const safeTotal = Number(total || 0)
  const percent = safeTotal > 0 ? Math.round((safeValue * 100) / safeTotal) : 0

  return {
    label,
    value: safeValue,
    percent,
    color
  }
}

export default {
  async get(eventId, options = {}) {
    const empty = {
      confirmations: [],
      tables: [],
      confirmationTotal: 0,
      tableTotal: 0
    }

    if (!eventId) {
      return empty
    }

    try {
      const bundle = await dashboardBundleService.get(eventId, options)
      const metrics = bundle.metrics || {}
      const guests = bundle.guests || []

      const totalGuests = Number(metrics.total || guests.length || 0)
      const confirmed = Number(metrics.confirm || 0)
      const pending = Number(metrics.pending || 0)
      const declined = Number(metrics.canceled || 0)
      const confirmationTotal = totalGuests

      const assignedRaw = guests.filter(g => Number(g.event_table_id || 0) > 0).length
      const assigned = Math.min(assignedRaw, totalGuests)
      const withoutTable = Math.max(totalGuests - assigned, 0)
      const tableTotal = totalGuests

      return {
        confirmations: [
          buildSegment('Confirmados', confirmed, confirmationTotal, '#4a8f5e'),
          buildSegment('Pendientes', pending, confirmationTotal, '#c4a948'),
          buildSegment('No asistiran', declined, confirmationTotal, '#b85b5b')
        ],
        tables: [
          buildSegment('Asignados', assigned, tableTotal, '#668269'),
          buildSegment('Sin mesa', withoutTable, tableTotal, '#637084')
        ],
        confirmationTotal,
        tableTotal
      }
    } catch (error) {
      return empty
    }
  },

  invalidate(eventId) {
    dashboardBundleService.invalidate(eventId)
  }
}
